export default "__VITE_ASSET__d52bf645__"